<template>
  <transition name="tr-expand">
  <tr class="tr-expand" v-if="active">
    <td :colspan="colspan">
      <div class="content-tr-expand">
        <slot></slot>
        <vs-button type="flat" @click="$emit('accept', $event)" :size="size" icon-pack="feather" icon="icon-check-circle" color="success"></vs-button>
        <button
          @click="$emit('cancel', $event)"
          v-if="close" class="tr-expand--close">
          <i class="material-icons">
            clear
          </i>
        </button>
      </div>
    </td>
  </tr>
  </transition>
</template>

<script>
export default {
  props: {
    close: {
      type: Boolean,
      default: false
    },
    colspan:{
      default: 1,
      type: Number | String
    },
    size: {
      default: 'large',
      type: String
    },
    active: {
      default: false,
      type: Boolean | String
    }
  },
  data:() => ({
    // active: false
  }),
  mounted() {
    this.active = true
  }
}
</script>
